module.exports = "https://static.wmbcdn.com/uniweb/images/da1a0532a889ff669e51d064d27bd182.svg";